import styled from 'styled-components'

import { media } from 'components/presentational'

const indent = 15

export const Wrapper = styled.div`
  margin: -${indent}px 0;

  ${media.tablet`
    margin: -${indent}px 10px;
  `}
`
